module.exports = __webpack_public_path__ + "d7220c7f85ce76192020fb6872bc3f38.svg";